import _ChevronRight from "@mui/icons-material/ChevronRight";
import _Box from "@mui/material/Box";
import _Skeleton from "@mui/material/Skeleton";
import _Typography from "@mui/material/Typography";
import _Button2 from "@mui/material/Button";
import React from 'react';
import { useTranslation } from 'react-i18next';
import useGameTeamsQuery from '../../../hooks/use-game-teams-query';
function BfgExploreMapCard({
  Button: _Button,
  event,
  ownGeogroup,
  selectTab
}) {
  const {
    t
  } = useTranslation();
  const Button = _Button || _Button2;
  const {
    data: myTeamResult
  } = useGameTeamsQuery(event.h3GameId ?? undefined, {
    groupIds: ownGeogroup ? [ownGeogroup.id] : undefined
  });
  const visitedTileCount = event.h3GameId && ownGeogroup && myTeamResult ? myTeamResult[0]?.visitedTileCount ?? 0 : undefined;
  return /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#ECFBF4",
    border: "1px solid #DDE0E7",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    padding: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontSize: 24,
      lineHeight: 1
    }
  }, "\uD83C\uDF33"), visitedTileCount === undefined ? /*#__PURE__*/React.createElement(_Skeleton, {
    height: 24,
    variant: "text",
    width: 120
  }) : /*#__PURE__*/React.createElement(_Typography, {
    sx: {
      fontSize: 16,
      fontWeight: 700
    }
  }, t('commons.challenges.bfg_explore_map_card.title', {
    count: visitedTileCount
  }))), /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    sx: {
      fontSize: 12,
      lineHeight: 1.5
    }
  }, t('commons.challenges.bfg_explore_map_card.description')), /*#__PURE__*/React.createElement(_Box, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    endIcon: /*#__PURE__*/React.createElement(_ChevronRight, null),
    onClick: () => selectTab('explorationMap'),
    variant: "contained"
  }, t('commons.challenges.bfg_explore_map_card.cta'))));
}
export default BfgExploreMapCard;